import { httpV2 } from "@/api/index";

/**
 * @summary Obtém as informações das configurações dos sinais de um diagnóstico.
 * @param {number} id - Id do sinal da tabela de diagnóstico.
 * @returns {promise} Promise da chamada da API.
 */
const GetSignalSettings = function(id)
{
	return httpV2.get(`/ParallelMisalignmentGeneratorShaftSignals/${id}/Limits`);
};

/**
 * @summary Atualiza as configurações de um diagnóstico.
 * @param {number} monitoringElementId - Id de monitoração da turbina.
 * @param {object} diagnosticSettingModel - Modelo com as configurações novas.
 * @returns {promise} Promise da API.
 */
const PutDiagnosticSettings = async function(monitoringElementId = 0, diagnosticSettingModel)
{
	return httpV2.put(`/ParallelMisalignmentGeneratorShaftSignals/${monitoringElementId}`, diagnosticSettingModel);
};

export default { GetSignalSettings, PutDiagnosticSettings };